import { InjectionToken } from '@angular/core';

import type { TutorialDialogContext } from './tutorial-dialog.types';

export type TutorialDialogContentTranslation = Record<
  TutorialDialogContext,
  Record<string, { title: string; description: string }>
>;

export interface TutorialDialogModuleTranslations {
  dialogBody: {
    learnMore: string;
    skip: string;
    continue: string;
    finish: string;
    startTour?: string;
  };
  tutorials: Record<string, any>;
}

export const TutorialTranslations = new InjectionToken<TutorialDialogModuleTranslations>(
  'TutorialModuleTranslations',
);
